import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('loan-product');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    getHistory(
        ctx,
        {
            id,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'startDate',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/loan-products/${id}/history`, {
            params
        });
    },

    changeStockAmount(ctx, { id, by }) {
        return axios.$post(`/admin/loan-products/${id}/change-stock-amount`, {
            by
        });
    }
};
